// Description truncation functionality
window.setupDescriptionTruncation = function setupDescriptionTruncation() {
    const descriptionElement = document.querySelector(
        ".theme-info-description"
    );
    
    if (!descriptionElement) return;
    
    const fullText = descriptionElement.textContent.trim();
    const wordLimit = 20;
    const words = fullText.split(" ");

    if (words.length > wordLimit) {
        const truncatedText = words.slice(0, wordLimit).join(" ") + "...";
        descriptionElement.textContent = truncatedText;

        const readMoreButton = document.createElement("button");
        readMoreButton.innerHTML = "Read More";
        readMoreButton.className = "read-more-button";
        descriptionElement.parentElement.appendChild(readMoreButton);

        readMoreButton.addEventListener("click", function () {
            if (descriptionElement.textContent === truncatedText) {
                descriptionElement.textContent = fullText;
                readMoreButton.innerHTML = "Read Less";
            } else {
                descriptionElement.textContent = truncatedText;
                readMoreButton.innerHTML = "Read More";
            }
        });
    }
}
